import { render, staticRenderFns } from "./education-administration.vue?vue&type=template&id=6a42853a&scoped=true&"
import script from "./education-administration.vue?vue&type=script&lang=js&"
export * from "./education-administration.vue?vue&type=script&lang=js&"
import style0 from "./education-administration.vue?vue&type=style&index=0&id=6a42853a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a42853a",
  null
  
)

export default component.exports